<!-- Define Variables -->

@let chartLabels = ['Entered','Not Entered','Planned Downtime'];
@let chartColors = ['green','red','grey'];

<!-- Define the mat-card to hold the dashboard in -->
<mat-card appearance="outlined"  class="current-complete-card mat-elevation-z8">
    <mat-card-header style="padding-left: 32px;">
        <mat-card-title>Today's Root Cause Entry Status</mat-card-title>
        <mat-card-subtitle>

        <!-- Legend -->
        <mat-accordion>
            <mat-expansion-panel expanded=false>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                    Legend
                    </mat-panel-title>
                </mat-expansion-panel-header>
                
                <mat-card appearance="outlined" class="legend mat-elevation-z8">
                    <div class="fx-row-start-center">
                        <div class="legend-icon-content">
                            <gea-mes-piechart
                                [labels]=chartLabels
                                [colors]=chartColors
                                [values]="[1,1,1]">
                            </gea-mes-piechart></div>
                        <div>The pie chart will have up to three slices.
                            <ul>
                            <li>Green - Percentage with a root cause entered</li>
                            <li>Red - Percentage with no root cause</li>
                            <li>Gray - Planned Downtime</li>
                            </ul>
                        </div>
                    </div>
                </mat-card>
                <mat-card appearance="outlined" class="legend mat-elevation-z8">
                    <div class="fx-row-start-center">
                    <div class="legend-icon-content"><mat-icon  style="transform: scale(2);" matTooltip="No Proficy Schedule">event_busy</mat-icon></div>
                    <div>No Schedule Loaded in Proficy for this time period.</div>
                    </div>
                </mat-card>            
            </mat-expansion-panel>
        </mat-accordion>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        @if (isLoading) {
            <mat-spinner value="100" class="spinner"></mat-spinner>
        }

        <!-- Button Bar -->
        <div class="button-bar">
            <button mat-button color="primary" (click)="navigate()">All Sites</button>
            
            @if (selectedPlantName != '') {
                <button mat-button [matMenuTriggerFor]="menu" class="center-icon-button" color="primary">{{selectedPlantName}}<mat-icon>arrow_drop_down</mat-icon></button>
                <mat-menu #menu="matMenu">
                    @for (plant of objectList; track $index) {
                        <button mat-menu-item (click)="changePlantName(plant.Description)">{{plant.Description}}</button>
                    }
                </mat-menu>  
            }

            @if (selectedLine != '') {
                <button mat-button [matMenuTriggerFor]="menu2" class="center-icon-button" color="primary">{{selectedLine}}<mat-icon>arrow_drop_down</mat-icon></button>
                <mat-menu #menu2="matMenu">
                    @for (line of lineMenuData; track $index) {
                        <button mat-menu-item (click)="changeLine(line.Description)">{{line.Description}}</button>
                    }
                </mat-menu>
            }

            @if (selectedSubLine != '') {
                <button mat-button [matMenuTriggerFor]="subSectionMenu" class="center-icon-button" color="primary">{{selectedSubLine}}<mat-icon>arrow_drop_down</mat-icon></button>
                <mat-menu #subSectionMenu="matMenu">
                    @for (subLine of subLineMenuData; track $index) {
                        <button mat-menu-item (click)="changeSubLine(subLine.Description)">{{subLine.Description}}</button>
                    }
                </mat-menu> 
            }
        </div>

        <!-- Define Header Line for Desktop View -->
        <div class="grid-container-shiftdate desktop-only">
            <div class="name shift-label"><h3>Name</h3></div>
            <div class="shift1 shift-label"><h3>1st Shift</h3></div>
            <div class="shift2 shift-label"><h3>2nd Shift</h3></div>
            <div class="shift3 shift-label"><h3>3rd Shift</h3></div>
            <div class="divider">
                <mat-divider></mat-divider>
            </div>
        </div>

        <!-- Define the dashboard lines -->
        @for (d of shiftDateOverview; track $index) {
            <div class="grid-container-shiftdate row">
                <div class="divider">
                    <mat-divider></mat-divider>
                </div>

                <div class="name name-row column">
                    @if (d.ObjectID != '')  {
                        <!-- Link for Object -->
                        <a [routerLink]="['/metrics/', d.Site, d.ObjectID]" class="flex-center"><mat-icon>list_alt</mat-icon>{{d.DisplayName}}</a>
                    } @else {
                        <!-- Button for Plant/Line/Subline-->
                        <button  mat-button color="primary" (click)="onClickName(d.DisplayName)"><mat-icon>grid_view</mat-icon>{{d.DisplayName}}</button>
                    }
                </div>
                
                <!-- label1, 2, 3 are mobile headers that should be shown for each plant-->
                <div class="label1 mobile-only shift-label"><h3>1st Shift</h3></div>
                <div class="label2 mobile-only shift-label"><h3>2nd Shift</h3></div>
                <div class="label3 mobile-only shift-label"><h3>3rd Shift</h3></div>        

                <div class="shift1 column">
                    @if (d.SHIFT1_SCHEDULED == 0) {
                        <!-- No Proficy Schedule show icon -->
                        <mat-icon style="transform: scale(2);" matTooltip="No Proficy Schedule">event_busy</mat-icon>
                    } @else {
                        @if (d.SHIFT1_TOTAL_DURATION == 0) {
                            <!-- SHIFT1_TOTAL_DURATION is 0, show all green -->
                            <gea-mes-piechart 
                                [labels]="['No Faults']"
                                [colors]="['white']"
                                [values]="[-1]">
                            </gea-mes-piechart>
                        } @else {
                            <!-- Show regular pie chart -->
                            <gea-mes-piechart
                                [labels]=chartLabels
                                [colors]=chartColors
                                [values]="[d.SHIFT1_ENTERED_DURATION,d.SHIFT1_NOT_ENTERED_DURATION,d.SHIFT1_PLANNED_DURATION]">
                            </gea-mes-piechart>
                        }
                        
                        <div class="shift_dates">
                            ( {{d.SHIFT1_DATES}} )
                        </div>
                    }
                </div>

                <div class="shift2 column">
                    @if (d.SHIFT2_SCHEDULED == 0) {
                        <!-- No Proficy Schedule show icon -->
                        <mat-icon style="transform: scale(2);" matTooltip="No Proficy Schedule">event_busy</mat-icon>
                    } @else {
                        @if (d.SHIFT2_TOTAL_DURATION == 0) {
                            <!-- No Faults yet, show a blank chart -->
                            <gea-mes-piechart 
                                [labels]="['No Faults']"
                                [colors]="['white']"
                                [values]="[-1]">
                            </gea-mes-piechart>
                        } @else {
                            <!-- Show regular pie chart -->
                            <gea-mes-piechart
                                [labels]=chartLabels
                                [colors]=chartColors
                                [values]="[d.SHIFT2_ENTERED_DURATION,d.SHIFT2_NOT_ENTERED_DURATION,d.SHIFT2_PLANNED_DURATION]">
                            </gea-mes-piechart>
                        }
                        
                        <div class="shift_dates">
                            ( {{d.SHIFT2_DATES}} )
                        </div>
                    }
                </div>

                <div class="shift3 column">
                    @if (d.SHIFT3_SCHEDULED == 0) {
                        <!-- No Proficy Schedule show icon -->
                        <mat-icon style="transform: scale(2);" matTooltip="No Proficy Schedule">event_busy</mat-icon>
                    } @else {
                        @if (d.SHIFT3_TOTAL_DURATION == 0) {
                            <!-- No Faults yet, show a blank chart -->
                            <gea-mes-piechart 
                                [labels]="['No Faults']"
                                [colors]="['white']"
                                [values]="[-1]">
                            </gea-mes-piechart>
                        } @else {
                            <!-- Show regular pie chart -->
                            <gea-mes-piechart
                                [labels]=chartLabels
                                [colors]=chartColors
                                [values]="[d.SHIFT3_ENTERED_DURATION,d.SHIFT3_NOT_ENTERED_DURATION,d.SHIFT3_PLANNED_DURATION]">
                            </gea-mes-piechart>
                        }
                        
                        <div class="shift_dates">
                            ( {{d.SHIFT3_DATES}} )
                        </div>
                    }
                </div>
            </div>
        }
    </mat-card-content>

</mat-card>